module.exports = __webpack_public_path__ + "img/bluesolar_75_10.72633432.png";